export default __webpack_public_path__ + "static/5-yoga-retreats-to-check-out-indonesia-86af7d2d4394a4a8caddc1a652a7fdd0.jpg";